import React from 'react';
import Select from 'react-select';
import { Field, ErrorMessage, FormikValues } from 'formik';

const CustomSelect: React.FC<FormikValues> = ({ label, name, options, isRequired = false, ...rest }) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>{label}{isRequired ? <span className='text-danger'>*</span> : ''}</label>
      <Field name={name}>
        {({ field, form }: any) => (
          <Select
            {...field}
            {...rest}
            options={options}
            onChange={(option) => form.setFieldValue(name, option)}
            onBlur={() => form.setFieldTouched(name, true)}
          />
        )}
      </Field>
      <ErrorMessage name={name} component="div" className="error" />
    </div>
  );
};

export default CustomSelect;
